<template>
  <header class="dropshadow">
    <div class="header__wrapper">
      <div class="header__logo">
        <a href="https://medoor.com/webmed/">
          <img src="https://medoor.com/image/base/logo.svg" alt="Door オンライン診療アプリ"/>
          <h1 class="header__logo-headline">into 健康医療相談</h1>
        </a>
      </div>
    </div>
  </header>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
.dropshadow {
  -webkit-filter: drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.2));
  -moz-filter: drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.2));
  -ms-filter: drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.2));
  filter: drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.2));
}
header {
  height: 55px;
  margin-top: 5px;
  box-shadow: 0 3px 3px 0 rgb(0 0 0 / 15%);
  justify-content: center;
  .header__wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    max-width: 100%;
    padding: 2px 15px;
    a {
      display: inline-block;
      width: 100%;
    }
    h1 {
      font-weight: 400;
    }
  }
  .header__logo {
    width: 90px;
    text-align: right;
    a {
      text-decoration: none;
    }
    img {
      vertical-align: bottom;
      height: auto;
      max-width: 100%;
    }
  }
  .header__logo-headline {
    color: #3D3D3D;
    text-decoration: none;
    margin-top: 3px;
    font-size: 10px;
    width: 100px;
    text-align: left;
  }
}
</style>

<style lang="scss">
.v-application {
  font-family: "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ ProN W3", "メイリオ", Meiryo, sans-serif !important;
}
</style>
